import axios from "axios";
import { toast } from "react-toastify";
import { URL_API } from "../../utils/helper/helpers";
import { useEffect, useState } from "react";
interface NumBonsInterface {
    [key: string]: any;
}

interface MaterielPriceInterface {
    [key: string]: any;
}

const useNumBons = (refresh: boolean): NumBonsInterface[] => {
    const [numBons, setNumBons] = useState<NumBonsInterface[]>([]);
    const Token = JSON.parse(localStorage.getItem("login")!);

    useEffect(() => {
        const fetchNumBons = async () => {
            axios.get(`${URL_API}/num-bons`, {
                headers: {
                    Authorization: `Bearer ${Token}`
                }
            }).then(response => {

                if (response.data.success) {
                    setNumBons(response.data.num_bons);
                }

            }).catch(error => {
                if (error.response.status === 400) {
                    toast.info(error.response.data.message);
                }

                if (error.response.status === 500) {
                    toast.warning(error.response.data.message);
                }
            })
        };

        fetchNumBons();
    }, [refresh]);
    return numBons;
};
export default useNumBons;

export const downloadPreuve = async (id: string, url: string) => {

    if (!id) {
        return;
    }
    const Token = JSON.parse(localStorage.getItem("login")!);

    try {
        const response = await axios.get(`${URL_API}/download-preuve/${id}`, {
            headers: { Authorization: `Bearer ${Token}` },
            responseType: 'blob',
        });

        const fileUrl = window.URL.createObjectURL(new Blob([response.data]));

        const link = document.createElement('a');
        link.href = fileUrl;
        link.setAttribute('download', "BonDeCommande_" + (url.split('/').pop() || 'document'));
        document.body.appendChild(link);
        link.click();
        link.remove();
    } catch (error) {
        toast.info('Erreur lors du téléchargement du fichier');
    }
};

export const deleteBonCommande = ({ id }: { id: number }, onSuccess: () => void) => {
    const Token = JSON.parse(localStorage.getItem("login")!);
    axios.post(`${URL_API}/bon/destroy/${id}`, {}, {
        headers: {
            Authorization: `Bearer ${Token}`
        }
    }).then(response => {

        if (response.data.success) {
            toast.info(response.data.message)
            onSuccess();
        }

    }).catch(error => {
        if (error.response.status === 400) {
            toast.info(error.response.data.message)
        }
        if (error.response.status === 500) {
            toast.info(error.response.data.message)
        }
    })
}

export const useMaterielPriceForLaffrage = (): MaterielPriceInterface[] => {
    const Token = JSON.parse(localStorage.getItem("login")!);
    const [materielPrice, setMaterielPrice] = useState<MaterielPriceInterface[]>([]);

    useEffect(() => {
        axios.get(`${URL_API}/laffrage/bons/materiel-price`, {
            headers: {
                Authorization: `Bearer ${Token}`
            }
        }).then(response => {
            if (response.data.success) {
                setMaterielPrice(response.data.materiel_price);
            }
        }).catch(error => {
            toast.info(error.response?.data?.message || "An error occurred");
        });
    }, []);
    return materielPrice;
};

